import { Checkbox, FormLabel, Textarea, WysiwygEditor } from "shared";
import { ICommonTemplateComponentProps, ITemplateComponent, stringToWysiwygSettings } from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import styles from "./tooltip_field.module.scss";

interface ITooltipFieldProps {
    component: ITemplateComponent;
    enLanguageEnabled: boolean;
    onChange: (value: Partial<ICommonTemplateComponentProps>) => void;

}

export const TooltipField: React.FC<ITooltipFieldProps> = React.memo(({
                                                                          component,
                                                                          enLanguageEnabled,
                                                                          onChange
                                                                      }) => {
    const t = useComponentsTranslations();

    const onFieldChange = (value: Partial<ICommonTemplateComponentProps>) => {
        onChange(value);
    };

    return <div className={styles.container}>
        <Checkbox
            id="component_use_wysiwyg_tooltip"
            label={t("useWysiwygMarkup")}
            size="m"
            onChange={() => onFieldChange({ useWysiwygTooltip: !component.useWysiwygTooltip })}
            checked={component.useWysiwygTooltip}
        />
        {component.useWysiwygTooltip && <FormLabel title={t("tooltip")}>
            <WysiwygEditor
                id="component_wysiwyg_tooltip"
                onChange={(value) => onFieldChange({ wysiwyg_tooltip: JSON.stringify(value) })}
                initialValue={stringToWysiwygSettings(component.wysiwyg_tooltip)}
            />
        </FormLabel>}
        {enLanguageEnabled && component.useWysiwygTooltip && <FormLabel title={t("tooltipEn")}>
            <WysiwygEditor
                id="component_wysiwyg_tooltip_en"
                onChange={(value) => onFieldChange({ wysiwyg_tooltip_en: JSON.stringify(value) })}
                initialValue={stringToWysiwygSettings(component.wysiwyg_tooltip_en)}
            />
        </FormLabel>}
        {!component.useWysiwygTooltip && <FormLabel title={t("tooltip")}>
            <Textarea id="component_field_tooltip"
                      name="tooltip"
                      value={component.tooltip ? component.tooltip : ""}
                      onChange={(e: any) => onFieldChange({ tooltip: e.target.value })}/>
        </FormLabel>}
        {!component.useWysiwygTooltip && enLanguageEnabled && <FormLabel title={t("tooltipEn")}>
            <Textarea id="component_field_tooltip_en"
                      name="tooltip_en"
                      value={component.tooltip_en ? component.tooltip_en : ""}
                      onChange={(e: any) => onFieldChange({ tooltip_en: e.target.value })}/>
        </FormLabel>}
    </div>;

});
